import React, { useCallback } from 'react'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './LikeOrDislikeInput.styled'

const LikeOrDislikeInput = ({ className, id, label, value, setValue }) => {
  const { t } = useTranslation()

  const handleChange = useCallback(
    (event) => {
      setValue(event.target.value)
    },
    [setValue],
  )

  return (
    <Styled className={className}>
      <Styled.label>{label}</Styled.label>
      <Styled.inputs>
        <Styled.input
          type="radio"
          id={`${id}-dislike`}
          name={`${id}-like-or-dislike`}
          value="dislike"
          checked={value === 'dislike'}
          onChange={handleChange}
        />
        <Styled.inputLabel htmlFor={`${id}-dislike`} title={t('DISLIKE')}>
          <span role="img" aria-label={t('DISLIKE')}>
            👎
          </span>
        </Styled.inputLabel>
        <Styled.input
          type="radio"
          id={`${id}-like`}
          name={`${id}-like-or-dislike`}
          value="like"
          checked={value === 'like'}
          onChange={handleChange}
        />
        <Styled.inputLabel htmlFor={`${id}-like`} title={t('LIKE')}>
          <span role="img" aria-label={t('LIKE')}>
            👍
          </span>
        </Styled.inputLabel>
      </Styled.inputs>
    </Styled>
  )
}

LikeOrDislikeInput.defaultProps = {
  id: 'like-or-dislike',
}

export default LikeOrDislikeInput
